export default {
  LEGACY: {
    ENDPOINT_LOCAL: "http://127.0.0.1:8082",
    ENDPOINT_AMOY: "https://pablock-api-dev.bcode.cloud",
    ENDPOINT_POLYGON: "https://pablock-api.bcode.cloud",

    CHAIN_ID_LOCAL: 1,
    CHAIN_ID_AMOY: 80002,
    CHAIN_ID_POLYGON: 137,

    RPC_PROVIDER_LOCAL: "http://127.0.0.1:7545",
    RPC_PROVIDER_AMOY: "https://rpc-amoy.polygon.technology/",
    RPC_PROVIDER_POLYGON: "https://rpc-mainnet.maticvigil.com/",

    PABLOCK_TOKEN_ADDRESS_LOCAL: "0x9e0296fDfaB97c428507e36f077177EbDC4e5Faf",
    PABLOCK_META_TRANSACTION_LOCAL:
      "0x3A2faCBF588DA64Ef94D90049d529f3862b7a6fb",
    PABLOCK_NOTARIZATION_LOCAL: "0x4aC8ED5D389755b48992C2A3850727f8D878ed26",
    PABLOCK_NFT_LOCAL: "0x272B411731CDF59a87250bEEB0A8F7031E98b86D",
    PABLOCK_MULTISIGN_FACTORY_LOCAL:
      "0xc36E2D4a155066423bD6f51A53CAe753353aFd5d",
    TEST_META_TX_LOCAL: "0xbFa175f1930833dE77bcE8a185b48Cc60bDb81a4",

    PABLOCK_TOKEN_ADDRESS_AMOY: "0x6e7aCfb649c85CB8b8307b4F7057E67E9B320BEA",
    PABLOCK_META_TRANSACTION_AMOY: "0x7296EE0F1036eC74eCF111E676e70eE97597A7d1",
    PABLOCK_NOTARIZATION_AMOY: "0x4816791f03b35C933e897702158dAf1164BFbdCc",
    PABLOCK_NFT_AMOY: "0xC17483c9214F579011EC3a45CC7B0FeC3bC65D58",
    PABLOCK_MULTISIGN_FACTORY_AMOY:
      "0x5818Ab1f26F8768D5a28c9823590E4b2eC3bb0C9",
    TEST_META_TX_AMOY: "0xE518725c53B4272d72c10b623A8443B62D19Ef1E",

    PABLOCK_TOKEN_ADDRESS_POLYGON: "0x284a7eF2ADD52890980E0173469FDE45d172bABD",
    PABLOCK_META_TRANSACTION_POLYGON:
      "0x5Dc63336bA6d4c1688E51e91fD7B002FC58C2dc9",
    PABLOCK_NOTARIZATION_POLYGON: "0xa347328B5b71eCFFcA8Da951AE2bDDa42F32066D",
    PABLOCK_NFT_POLYGON: "0x5979b9697C7ff4AD8925680a0998C449F070E962",
    PABLOCK_MULTISIGN_FACTORY_POLYGON:
      "0xDF4FEC568B4975AE4E39AAC576143d0E86dd2e1A",

    PABLOCK_ADDRESS_LOCAL: "0xfc8CFa30350f7B195f2b5c6F350f76720bfD89f4",
  },
  V1: {
    DEV: {
      APIKEY: "AIzaSyByXFn-gAW0Uz3IskHh5yhyHlfzYeO4OZM",
      AUTHDOMAIN: "databox-dev-2a26f.firebaseapp.com",
      PROJECTID: "databox-dev-2a26f",
      STORAGE_BUCKET: "databox-dev-2a26f.appspot.com",
      MESSAGGING_SENDER_ID: 216890287837,
      APP_ID: "1:216890287837:web:ca12c83800b01b32f69d34",
      RTDB_FIREBASE:
        "https://databox-dev-2a26f-default-rtdb.europe-west1.firebasedatabase.app",
      RTDB_FIREBASE_MESSAGE:
        "https://databox-dev-messages.europe-west1.firebasedatabase.app",
      BCODE_META_TRANSACTION: "0x7296EE0F1036eC74eCF111E676e70eE97597A7d1",
      // BACKEND_ENDPOINT: "http://localhost:8080",
      BACKEND_ENDPOINT: "https://api.dev.bcode.cloud",
      RPC_PROVIDER: "https://rpc-amoy.polygon.technology/",
      CHAIN_ID: 80002,
    },
    DEMO: {
      APIKEY: "AIzaSyAuG7wBP4AGfrqz51sp7_J16Ovpwxah4EE",
      AUTHDOMAIN: "databox-demo-ed222.firebaseapp.com",
      PROJECTID: "databox-demo-ed222",
      STORAGE_BUCKET: "databox-demo-ed222.appspot.com",
      MESSAGGING_SENDER_ID: 964739159778,
      APP_ID: "1:964739159778:web:5f60da23eeb0867946f0bb",
      RTDB_FIREBASE:
        "https://databox-demo-ed222-default-rtdb.europe-west1.firebasedatabase.app",
      RTDB_FIREBASE_MESSAGE: "",
      BCODE_META_TRANSACTION: "0x7296EE0F1036eC74eCF111E676e70eE97597A7d1",
      BACKEND_ENDPOINT: "http://api.demo.bcode.cloud",
      RPC_PROVIDER: "https://rpc-amoy.polygon.technology/",
      CHAIN_ID: 80002,
    },
    PROD: {
      APIKEY: "AIzaSyCprxjrITEM5qWPq92Ns5K4ZgfPITRRshY",
      AUTHDOMAIN: "databox-60725.firebaseapp.com",
      PROJECTID: "databox-60725",
      STORAGE_BUCKET: "databox-60725.appspot.com",
      MESSAGGING_SENDER_ID: 519196124682,
      APP_ID: "1:519196124682:web:b7e8d8547239c3c10fe1f3",
      RTDB_FIREBASE:
        "https://databox-60725-default-rtdb.europe-west1.firebasedatabase.app",
      BCODE_META_TRANSACTION: "0x5Dc63336bA6d4c1688E51e91fD7B002FC58C2dc9",
      BACKEND_ENDPOINT: "http://api.bcode.cloud",
      RTDB_FIREBASE_MESSAGE: "",
      RPC_PROVIDER: "https://polygon-rpc.com",
      CHAIN_ID: 137,
    },
  },
};
